import type { IService } from 'restangular'

import { app } from '../../app.module'

/**
 * CsvダウンロードTrendWordサービス
 */
export class CsvDownloadTrendWord {
  constructor(
    private Restangular: IService,
    private $q: ng.IQService
  ) {}

  /**
   * トレンドワード一覧をCSVとしてダウンロード
   * @param  {object} getOptions フィルタリングの要件
   * @return {Function} トレンドワード一覧のCSVデータをPromiseとしてリターン
   */
  public download(getOptions) {
    const deferred = this.$q.defer()
    const csvData = []

    // データを全件ダウンロードするため、LIMITを外す
    getOptions.limit = null

    const requestUrl = 'trendword/getTrendWord?get_options=' + JSON.stringify(getOptions)

    // データを取得し、トレンドワードごとにデータを整形して配列に格納する
    this.Restangular.all(requestUrl)
      .getList()
      .then((response) => {
        if (response[0].data !== null) {
          const trendWords = response[0].data.trendWordData
          const dataHeader = ['日付', '時間', '順位', 'タイプ', 'トレンドワード']

          csvData.push(dataHeader)

          trendWords.forEach((data) => {
            const trendWordData = [
              data.datetime,
              data.hour + ':00',
              data.ranking,
              this.convertTrendWordType(data.type),
              data.wordName,
            ]
            csvData.push(trendWordData)
          })

          deferred.resolve(csvData)
        }
      })

    // promiseとしてリターンする
    return deferred.promise
  }

  /**
   * トレンドワードの種別を日本語に変換する
   * @param  {string} type トレンドワード種別
   * @return {string} 日本語に変換したトレンドワード
   */
  private convertTrendWordType(type) {
    let result = ''

    if (type === 'keyword') {
      result = 'キーワード'
    }
    if (type === 'hashtag') {
      result = 'ハッシュタグ'
    }
    return result
  }
}

// CSVダウンロード用のサービスを定義
app.service('CsvDownloadTrendWord', CsvDownloadTrendWord)
